import { render, staticRenderFns } from "./emergencyProcessCRUD.vue?vue&type=template&id=b21413e8&scoped=true&"
import script from "./emergencyProcessCRUD.vue?vue&type=script&lang=js&"
export * from "./emergencyProcessCRUD.vue?vue&type=script&lang=js&"
import style0 from "./emergencyProcessCRUD.vue?vue&type=style&index=0&id=b21413e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21413e8",
  null
  
)

export default component.exports